<div
    class="popup-modern-container"    
>
    <img  class="popup-modern-container-loder-icon" src="../../../assets/images/loader-battery.gif" alt="">
</div>

